class HomeAnimation {

	constructor(){
		this.animationElement = document.querySelectorAll(`[data-numberAnimation]`);
		this._init();
	}

	_init(){
		for(const item of this.animationElement){
			console.log('test')
			item.addEventListener('visible', (event)=>this._loadImages(event), {once: true} );
		}
	}


	_loadImages(event){
		const element  = event.target;

	  	jQuery({ Counter: 0 }).animate({ Counter: element.innerHTML }, {
	    	duration: 2000,
		    easing: 'swing',
		    step: function (i) {
		      	element.innerHTML = Math.ceil(i);
		    }
	  	});
	}
}

export const homeAnimation = new HomeAnimation();